import app from './helpers/app';
import preloadedServices from './preloaded-services';
import providers from './providers';

const kernel = app();
kernel.declareBindings(preloadedServices);

providers.forEach(kernel.registerProvider.bind(kernel));
